export interface ReopenGuard {
  acquire: (findingIds: string[]) => boolean;
  release: (findingIds: string[]) => void;
}

/**
 * Blokada per sprawa, nie per wiersz: „Cofnij” niesie wszystkie sprawy wiersza, „Przywróć” na liście
 * odłożonych — jedną z nich, więc klucz z całej listy nie łapał kliknięcia w trakcie i kończyło się 409.
 */
export const createReopenGuard = (): ReopenGuard => {
  const pending = new Set<string>();
  return {
    acquire: (findingIds) => {
      if (findingIds.some((id) => pending.has(id))) return false;
      findingIds.forEach((id) => pending.add(id));
      return true;
    },
    release: (findingIds) => findingIds.forEach((id) => pending.delete(id)),
  };
};
